import { LOCALE_ID, NgModule, Injector } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { BrowserModule } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { LoginRegisterComponent } from './login-register/login-register.component';
import { UserComponent } from './user/user.component';
import { ProductosComponent } from './productos/productos.component';
import { CestaComponent } from './cesta/cesta.component';
import { FooterComponent } from './footer/footer.component';
import { InlineEditComponent } from './inline-edit/inline-edit.component';
import { CuandoFechasPipe } from './pipes/cuando-fechas.pipe';
import { AutofocusDirective } from './directives/autofocus.directive';
import { AbsPipe } from './pipes/abs.pipe';
import { ComprasComponent } from './compras/compras.component';
import { PeriodoFechaPipe } from './pipes/periodo-fecha.pipe';
import { LoaderComponent } from './loader/loader.component';

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginRegisterComponent,
    UserComponent,
    ProductosComponent,
    CestaComponent,
    CuandoFechasPipe,
    FooterComponent,
    InlineEditComponent,
    AutofocusDirective,
    AbsPipe,
    ComprasComponent,
    PeriodoFechaPipe,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    DragDropModule,
    ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        progressBar: true
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    DatePipe
  ],
  //bootstrap: [AppComponent] // Quitar esto porque es un proyecto webelement
})
export class AppModule { 
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    // HEADER
    const headerEl = createCustomElement(HeaderComponent, { injector: this.injector });
    if (!customElements.get('angular-header')) {
      customElements.define('angular-header', headerEl);
    }
    // LOGIN REGISTER
    const loginRegisterEl = createCustomElement(LoginRegisterComponent, { injector: this.injector });
    if (!customElements.get('angular-login-register')) {
      customElements.define('angular-login-register', loginRegisterEl);
    }
    // PRODUCTOS
    const productosEl = createCustomElement(ProductosComponent, { injector: this.injector });
    if (!customElements.get('angular-productos')) {
      customElements.define('angular-productos', productosEl);
    }
    // COMPRAS
    const comprasEl = createCustomElement(ComprasComponent, { injector: this.injector });
    if (!customElements.get('angular-compras')) {
      customElements.define('angular-compras', comprasEl);
    }
  }

}
